import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { lighten } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import SearchBox from 'src/components/shared/EnhancedTable/SearchBox/SearchBox'
import { colors } from 'src/providers/globalVars'

const useToolbarStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing('5px', 1),
    minHeight: 0,
    backgroundColor: theme.colors.gray15
  },

  highlight:
    theme.palette.mode === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
        },

  title: {
    flex: '1 1 100%',
    color: colors.blue01,
    textTransform: 'uppercase'
  }
}))

type Props = {
  title?: string
  setSearchText: (searchText?: string) => void
  searchText: string
}

function TableToolbar({ title, setSearchText, searchText }: Props): JSX.Element {
  const classes = useToolbarStyles()
  return (
    <Toolbar className={classes.root}>
      {title && (
        <div className={classes.title}>
          <Typography color="inherit" variant="subtitle1">
            {title}
          </Typography>
        </div>
      )}
      <SearchBox searchText={searchText} setSearchText={setSearchText} />
    </Toolbar>
  )
}

export default TableToolbar
